<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
        <div class="padding">
          <p>The girl across the hall, the one with the tattoo, she's gone. It's such a shame and now another family moved in the same afternoon.</p>

          <p>She wasn't more than twenty, she had arms like a bird, like one of those thin gulls that sit by the water's edge and peck at the animals that come to drink. Her face was so beautiful, so fragile and now it's gone and I won't see her anymore.</p>

          <p>I can't find the edges of the city. I can't see the road out of the city, to the north. It's not there anymore,</p>

          <p>gone,</p>

          <p>like the girl,</p>

          <p>like breath</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'A Girl'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
